import React from 'react'
import IntlPolyfill from 'react-intl-polyfill'
import * as Sentry from '@sentry/react'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter } from 'react-router-dom'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import Tooltip from 'components/Tooltip'
import { Router } from 'router/Router'
import { GlobalStyle } from 'styles/global'
import { theme } from 'styles/theme'

function App() {
  return (
    <Sentry.ErrorBoundary fallback="An error has occured">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <IntlPolyfill locales={['en']} fallback={<div>Please wait...</div>}>
            <GlobalStyle />
            <Router />
            <Tooltip />
          </IntlPolyfill>
        </ThemeProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  )
}

export default App
